'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import publishes from './Publishes';
const reducers = combineReducers({
  publishes
});
let _state = EMPTY_OBJECT;
export default ((state, action) => {
  _state = SeamlessImmutable.merge(_state, reducers(state, action));
  return _state;
});